<template>
    <missing-info :card="!flat" large min-height="184" :text="text" :button="$t('label.contact')" @click="showContactModal = true" vertical>
        <lazy-ajax-form-modal v-model="showContactModal"
                              :form-options="{action: '/v1/contact', method: 'POST', data: contactData, reset: true}"
                              :modal-options="{title: $t('label.contact'), subtitle: text}"
                              @success="handleSubmittedContactMessage"
                              :submit-text="$t('action.send')">

            <lazy-contact-message-form-inputs :data="contactData" without-captcha/>

        </lazy-ajax-form-modal>

    </missing-info>
</template>

<script>

export default {
    name: 'MissingContactCard',

    props: {

        text: {
            type: String,
            required: true
        },

        contactPlaceholder: {
            type: String,
            required: true
        },

        location: {
            type: String,
            required: true
        },

        flat: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            contactData: {
                message: this.contactPlaceholder
            },
            showContactModal: false,
        }
    },

    methods: {
        handleSubmittedContactMessage() {
            this.$analytics.trackEvent('contact', {location: this.location
            });
        },
    }

}
</script>